import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import http from '@/api/http';

/**
 * 获取用户关联的所有学校（包含主学校和额外学校）
 * @param {number} userId 用户ID
 */
export function getUserAllSchools(userId) {
  return http.get("/api/v5/user-school/get-user-schools", {
    userId: userId
  });
}

/**
 * 获取用户关联的所有学校ID（包含主学校和额外学校）
 * @param {number} userId 用户ID
 */
export function getUserAllSchoolIds(userId) {
  return http.get("/api/v5/user-school/get-user-all-school-ids", {
    userId: userId
  });
}

/**
 * 获取用户的主学校
 * @param {number} userId 用户ID
 */
export function getUserPrimarySchool(userId) {
  return http.get("/api/v5/user-school/get-user-primary-school", {
    userId: userId
  });
}

/**
 * 获取用户的额外学校（不包含主学校）
 * @param {number} userId 用户ID
 */
export function getUserAdditionalSchools(userId) {
  return http.get("/api/v5/user-school/get-user-additional-schools", {
    userId: userId
  });
}

// mixin
export default {
  data: function data() {
    return {
      userSchool: {
        list: [],
        page: 1,
        size: 10,
        total: 0,
        model: null
      }
    };
  },
  /**
   * Mixin方法
   */
  methods: {
    // 获取用户所有学校
    fetchUserAllSchools: function fetchUserAllSchools() {
      var _arguments = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _ref, userId, data, options, response;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, userId = _ref.userId, data = _ref.data, options = _ref.options;
              _context.n = 1;
              return getUserAllSchools(userId);
            case 1:
              response = _context.v;
              return _context.a(2, response.data);
          }
        }, _callee);
      }))();
    },
    // 获取用户所有学校ID
    fetchUserAllSchoolIds: function fetchUserAllSchoolIds() {
      var _arguments2 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref2, userId, data, options, response;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref2 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, userId = _ref2.userId, data = _ref2.data, options = _ref2.options;
              _context2.n = 1;
              return getUserAllSchoolIds(userId);
            case 1:
              response = _context2.v;
              return _context2.a(2, response.data);
          }
        }, _callee2);
      }))();
    },
    // 获取用户主学校
    fetchUserPrimarySchool: function fetchUserPrimarySchool() {
      var _arguments3 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _ref3, userId, data, options, response;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _ref3 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, userId = _ref3.userId, data = _ref3.data, options = _ref3.options;
              _context3.n = 1;
              return getUserPrimarySchool(userId);
            case 1:
              response = _context3.v;
              return _context3.a(2, response.data);
          }
        }, _callee3);
      }))();
    },
    // 获取用户额外学校
    fetchUserAdditionalSchools: function fetchUserAdditionalSchools() {
      var _arguments4 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _ref4, userId, data, options, response;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _ref4 = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {}, userId = _ref4.userId, data = _ref4.data, options = _ref4.options;
              _context4.n = 1;
              return getUserAdditionalSchools(userId);
            case 1:
              response = _context4.v;
              return _context4.a(2, response.data);
          }
        }, _callee4);
      }))();
    }
  }
};